import React, { useEffect, useState } from 'react';
import { Card, LoaderAnimated } from '../../components';
import { CampaignHome } from './CampaignHome.component';

import { useParams } from 'react-router-dom';
import { useCampaignDispatch } from './Campaigns.hooks';
import { useAppDispatch } from '../../store';
import { LogDealActionBar } from '../OpportunityManagement/LogDealActionBar.component';
import { apiService, configService } from '../../services';
import { InteractionEventType } from 'outbound-api-client/lib/models';
import { CampaignEnrol } from './CampaignEnrol.component';
import { Helmet } from 'react-helmet';
import { CampaignEnrolmentValues } from './CampaignEnrolment.schema';
import { FormikHelpers } from 'formik';
import { t } from 'i18next';

export const CampaignTemplate: React.FC = () => {

  const dispatch = useAppDispatch();
  const { campaignId } = useParams();
  const { campaign, hasContent } = useCampaignDispatch(dispatch, campaignId || '');

  const [enrolled, setEnrolled] = useState<boolean>(false);
  const [enrolmentChecked, setEnrolChecked] = useState<boolean>(false);



  const onEnrolSubmit = async (formValues: CampaignEnrolmentValues, formikBag?: FormikHelpers<CampaignEnrolmentValues>) => {
    if (formValues.acceptedTerms) {
      await apiService.postInteraction(InteractionEventType.CampaignEnrol, `Enrol_${campaignId}_EN_GB`, campaignId, campaignId);
      setEnrolled(true);
    }
  }


  useEffect(() => {
    if (campaignId) {
      apiService.instance.isCampaignEnrolled(campaignId)
        .then((enrolmentStatus) => {
          if (enrolmentStatus && enrolmentStatus.length > 0) {
            setEnrolled(true);
          }
        })
        .finally(() => {
          setEnrolChecked(true);
        })
    }
  }, [enrolled])


  // Log "Page View" Interaction
  useEffect(() => {
    try {
      let path = window.location.pathname;
      apiService.postInteraction(InteractionEventType.WebPageView, 'PageView', path);
    } catch (err) {
      console.log(err);
    }
  }, []);





  const appId = process.env.REACT_APP_CLIENTID;
  if (["zebratechnologies"].includes(appId as string)) {
    return (!campaign || !hasContent) ? <LoaderAnimated /> : <>
      <CampaignHome {...campaign} />
    </>
  }


  if (["ricoh-rewards"].includes(appId as string)) {
    return (!campaign || !hasContent) ? <LoaderAnimated /> : <>
      <Helmet>
        <title>{configService.current().applicationTitle} - {campaign.title}</title>
      </Helmet>
      <main className={campaign.identifier?.toString() || campaignId}>
        {enrolled ? (
          <CampaignHome {...campaign} />
        ) : (<>
          <div className="banner" >
            <div className="container">
              <p>{t("page_enrol_heading")}</p>

              <div className="p-3">
                <div className="text-large">DESTINATION</div>
                <div className="text-x-large">TOKYO</div>
              </div>


              <p>POWERED BY RICOH CLOUDSTREAM</p>

            </div>
            <CampaignEnrol onEnrolSubmit={onEnrolSubmit} {...campaign} />
          </div>
        </>
        )}
      </main>
    </>
  }



  return (
    (!campaign || !hasContent) ? <LoaderAnimated /> :
      <Card cssClasses='m-x-0' contentCSS='p-x-0 p-bottom-2'>
        <div>
          <>
            <LogDealActionBar />
            <CampaignHome {...campaign} />
          </>
        </div>
      </Card>
  )
}